import React from 'react';
import {IconSVG} from "../icon/IconSVG";


export interface BreadcrumbListModel {
    name: string
    label: string
}

const Breadcrumb = ({list, nameActive, clickVoiceHandler}: {
    list: BreadcrumbListModel[],
    nameActive?: string,
    clickVoiceHandler?: (name: string) => void
}) => {

    return (
        <nav aria-label="breadcrumb">
            <ol className="breadcrumb py-2">
                {list?.map((ele, k) => (
                    <li key={k} className={`breadcrumb-item ${nameActive?.includes(ele.name) ? 'active' : ''}`}>
                        {k === 0 && <IconSVG icon={'./assets/icons/home.svg'} size={'12px'}/>}
                        <a href="#" onClick={() => clickVoiceHandler && clickVoiceHandler(ele.name)}>{ele.label}</a>
                    </li>
                ))}
            </ol>
        </nav>
    );
};

export default Breadcrumb;
